/**
 * Transaction Buyer Payment Status Redirect Route - React Router v7
 *
 * Routes: /transaction/buyer/payment-fail, /transaction/buyer/payment-success
 * Single component that reads the pathname to decide whether to show the success
 * or fail modal, then pushes the user to `/user/messages/#/id/<conversationId>`.
 * DO NOT normalize the trailing slash — the component compares raw pathname vs
 * ROUTES.TRANSACTION.BUYER_PAYMENT_* internally.
 */
/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-throw-literal, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing, no-console */
import type {LoaderFunctionArgs} from 'react-router-dom'
import {redirect, useLoaderData} from 'react-router-dom'

import {getInitialProps} from './getInitialProps.js'
import BuyerPaymentStatusRedirect from './index.js'

import './styles/index.scss'

export async function loader({context, request}: LoaderFunctionArgs) {
  const url = new URL(request.url)
  const query: Record<string, string> = {}
  url.searchParams.forEach((value, key) => {
    query[key] = value
  })
  const routeInfo = {
    location: {
      pathname: url.pathname, // raw, no trailing slash normalization
      search: url.search,
      query
    }
  }

  try {
    const initialProps = await getInitialProps({routeInfo, context})
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const httpRedirect = (initialProps as any)?.__HTTP__?.redirectTo
    if (httpRedirect) throw redirect(httpRedirect)
    return {...initialProps, __RR7__: true}
  } catch (error: unknown) {
    if (error instanceof Response) throw error
    console.error('[RR7] BuyerPaymentStatusRedirect loader error:', error)
    throw error
  }
}

export function Component() {
  const data = useLoaderData()
  return <BuyerPaymentStatusRedirect {...data} />
}

Component.displayName = 'TransactionBuyerPaymentStatusRedirectRoute'
